import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { useCreateMixingCartMutation, useUpdateMixingCartMutation } from "./mixingCartApi";

const MixingCartModal = ({ show, setShow, record, mode = "edit" }) => {
  const { _t } = useTranslator();
  const [formData, setFormData] = useState({
    name:           "",
    empty_weight:   "",
    max_tray_space: "",
  });

  const [createMixingCart, { isLoading: isCreating }] = useCreateMixingCartMutation();
  const [updateMixingCart, { isLoading: isUpdating }] = useUpdateMixingCartMutation();

  useEffect(() => {
    if (show) {
      if (mode === "edit" && record) {
        setFormData({
          name:           record.name           || "",
          empty_weight:   record.empty_weight   || "",
          max_tray_space: record.max_tray_space || "",
        });
      } else {
        setFormData({ name: "", empty_weight: "", max_tray_space: "" });
      }
    }
  }, [show, record, mode]);

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating || isUpdating) return;
    const payload = {
      name:           formData.name,
      empty_weight:   parseFloat(formData.empty_weight)   || 0,
      max_tray_space: parseFloat(formData.max_tray_space) || 0,
    };
    try {
      if (mode === "edit") {
        await updateMixingCart({ id: record.id, requestBody: payload }).unwrap();
      } else {
        await createMixingCart(payload).unwrap();
      }
      handleClose();
    } catch (err) {
      console.error("Error saving mixing cart:", err);
    }
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={mode === "edit" ? _t("edit_mixing_cart", "Edit Mixing Cart") : _t("add_cart", "Add Cart")}
    >
      <Row>
        <Col lg={6}>
          <InputWithLabel
            label={_t("cart_name", "Cart Name")}
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={_t("cart_name", "Cart Name")}
            // disabled={mode === "edit"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("empty_weight", "Empty Weight")}
            type="number"
            name="empty_weight"
            value={formData.empty_weight}
            onChange={handleChange}
            placeholder="0"
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("max_tray_space", "Max Tray Space")}
            type="number"
            name="max_tray_space"
            value={formData.max_tray_space}
            onChange={handleChange}
            placeholder="0"
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default MixingCartModal;
